var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeard2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141.445,
    height: "25mm",
    viewBox: "0 0 37.424 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#57433c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.102,
    d: "M6.824 14.799c1.545 1.346 5.598 3.312 8.252 2.564 2.637-.743 2.656-4.433 2.656-4.433H19.911s.02 3.69 2.656 4.433c2.655.748 6.707-1.218 8.252-2.564C34.271 11.79 36.732.773 36.732.773s.387 8.255-.1 11.242l-.224-.74c-.213 1.717-.589 3.147-1.626 4.337l-.134-.405a8.175 8.175 0 01-2.695 4.524l-.137-.697a9.126 9.126 0 01-4.35 3.692c-.014-.304-.025-.606-.038-.908a8.14 8.14 0 01-4.677 1.882c-.002-.166-.002-.333-.006-.498-1.719 1.35-3.923 1.35-3.923 1.35s-2.204 0-3.923-1.35c-.002.165-.002.332-.006.498a8.137 8.137 0 01-4.677-1.882c-.015.302-.026.604-.04.908a9.126 9.126 0 01-4.348-3.692l-.138.697a8.174 8.174 0 01-2.693-4.524l-.135.405c-1.036-1.19-1.413-2.62-1.625-4.337l-.224.74C.526 9.028.899.427.899.427S3.373 11.79 6.824 14.799z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeard2);
export default __webpack_public_path__ + "static/media/beard2.31a8037b560cc52b114db72853cb37fc.svg";
export { ForwardRef as ReactComponent };